<template>
  <div class="profile-container">
    <div class="profile-header">个人中心</div>
    <div class="profile-info-card">
      <div class="profile-avatar">👤</div>
      <div class="profile-nickname">您好，{{ displayName }}</div>
      <div class="profile-welcome">查看最新优惠券和账户动态</div>
    </div>
    <div class="profile-balance-card">
      <div class="profile-balance-row">
        <div class="profile-balance-item">
          <div class="profile-balance-label">账户余额</div>
          <div class="profile-balance-value">{{ displayBalance }}</div>
        </div>
        <div class="profile-balance-item">
          <div class="profile-balance-label">赠送余额</div>
          <div class="profile-balance-value">{{ displayGiftedBalance }}</div>
        </div>
      </div>
      <button class="profile-balance-btn" @click="goRecharge">账户充值</button>
    </div>
    <div class="profile-quick-grid">
      <div class="profile-quick-item" @click="$router.push('/account')"><div class="profile-quick-icon">📊</div><div class="profile-quick-label">账户明细</div></div>
      <div class="profile-quick-item" @click="$router.push('/coupon')"><div class="profile-quick-icon">🎫</div><div class="profile-quick-label">优惠券管理</div></div>
      <div class="profile-quick-item" @click="$router.push('/invoice/unissued')"><div class="profile-quick-icon">🧾</div><div class="profile-quick-label">电子发票</div></div>
      <div class="profile-quick-item" @click="$router.push('/settings')"><div class="profile-quick-icon">⚙️</div><div class="profile-quick-label">设置中心</div></div>
    </div>
    <BottomNav />
  </div>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue'
import { mapGetters, mapActions } from 'vuex'
import { getBusinessByUser } from '@/api/business'
import { formatUserName, formatPhone, formatBalance } from '@/utils/user'

export default {
  name: 'ProfilePage',
  components: { BottomNav },
  computed: {
    ...mapGetters(['nickname', 'realName', 'avatar', 'phone', 'balance', 'giftedBalance', 'userInfo']),
    displayName() {
      // 优先使用realName，如果没有则使用nickname
      return this.realName || this.nickname || formatUserName(this.userInfo)
    },
    displayPhone() {
      return formatPhone(this.phone)
    },
    displayBalance() {
      return formatBalance(this.balance)
    },
    displayGiftedBalance() {
      return formatBalance(this.giftedBalance)
    }
  },
  mounted() {
    this.loadUserInfo()
  },
  methods: {
    ...mapActions(['GetInfo', 'FetchMerchantBalance']),
    
    // 加载用户信息
    async loadUserInfo() {
      try {
        await this.GetInfo()
        // 额外从营销后端拉取并更新商户余额
        await this.FetchMerchantBalance()
        // 等待 Vue 响应式更新完成
        await this.$nextTick()
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },

    // 跳转充值并传递当前商户
    async goRecharge() {
      try {
        // 优先从 Vuex 获取
        let uid = (this.userInfo && (this.userInfo.userId || this.userInfo.id)) || null
        const opName = (this.realName || this.nickname || (this.userInfo && (this.userInfo.username || this.userInfo.userName)) || '') || ''
        if (!uid) {
          // 其次从 localStorage 获取
          uid = localStorage.getItem('userId')
        }
        if (!uid) {
          // 最后从 token 解析
          try {
            const tk = localStorage.getItem('token')
            const parts = (tk || '').split('.')
            if (parts.length === 3) {
              const payload = JSON.parse(atob(parts[1]))
              uid = payload.userId || payload.uid || payload.sub || null
            }
          } catch (e) { /* ignore */ }
        }
        if (!uid) return this.$router.push('/recharge')

        const resp = await getBusinessByUser(uid)
        const wrap = resp && resp.data ? resp.data : resp
        const biz = wrap && wrap.data ? wrap.data : wrap
        const businessId = biz && (biz.businessId || biz.id)
        const businessName = biz && (biz.businessName || biz.name)
        if (biz) {
          // 便于充值页或其他页面兜底使用
          try { localStorage.setItem('currentBusiness', JSON.stringify(biz)) } catch (e) { /* ignore */ }
        }
        // 将操作人信息一起传递
        this.$router.push({ path: '/recharge', query: { businessId, businessName, operatorId: uid, operatorName: opName } })
      } catch (e) {
        console.warn('获取商户信息失败，直接进入充值页：', e)
        this.$router.push('/recharge')
      }
    }
  }
}
</script>

<style scoped>
.profile-container {
  width: 100vw;
  max-width: 430px;
  min-height: 100vh;
  background: #f7f8fa;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 80px;
}

.profile-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

.profile-info-card {
  background: #fff;
  border-radius: 18px;
  margin: 24px 16px 0;
  padding: 24px 0 18px;
  box-shadow: 0 2px 8px #e0e0e033;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #eaf3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: #238aff;
  margin-bottom: 12px;
}

.profile-nickname {
  font-size: 20px;
  font-weight: bold;
  color: #222;
  margin-bottom: 4px;
}

.profile-welcome {
  color: #888;
  font-size: 15px;
  margin-bottom: 0;
}

.profile-balance-card {
  background: #fff;
  border-radius: 16px;
  margin: 18px 16px 0;
  padding: 24px 0;
  box-shadow: 0 2px 8px #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-balance-row {
  display: flex;
  width: 100%;
  gap: 20px;
  padding: 0 20px;
  margin-bottom: 20px;
}

.profile-balance-item {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-balance-label {
  font-size: 16px;
  color: #888;
  margin-bottom: 6px;
}

.profile-balance-value {
  font-size: 32px;
  color: #238aff;
  font-weight: bold;
  margin: 8px 0;
}

.profile-balance-btn {
  background: #238aff;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 12px;
  padding: 8px 32px;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.profile-balance-btn:active {
  background: #1a6bcc;
  transform: scale(0.98);
}

.profile-quick-grid {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  gap: 18px 0;
  margin: 32px 16px 0;
}

.profile-quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.1s;
}

.profile-quick-item:active {
  transform: scale(0.95);
}

.profile-quick-icon {
  width: 54px;
  height: 54px;
  background: #eaf3ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #238aff;
}

.profile-quick-label {
  font-size: 15px;
  color: #222;
  margin-top: 8px;
}
</style>
